// extracted by mini-css-extract-plugin
module.exports = {"privilege":"PrivilegeCheckbox_privilege__1Sa7Z","text":"PrivilegeCheckbox_text__qwJrd","checkbox":"PrivilegeCheckbox_checkbox__1i4xC"};